async function AddToCart_btn(id) {
  const cartObject =
    document.querySelector("cart-notification") ||
    document.querySelector("cart-drawer");
  let formData = new FormData();
  const quantity = document.getElementById("quantity").value;
  formData.append("items[][id]", id); // REPLACE BY YOUR ID
  formData.append("items[][quantity]", quantity); // REPLACE BY YOUR QUANTITY
  if (cartObject) {
    formData.append(
      "sections",
      cartObject.getSectionsToRender().map((section) => section.id)
    );
    formData.append("sections_url", window.location.pathname);
  }
  fetch(window.Shopify.routes.root + "cart/add.js", {
    method: "POST",
    body: formData,
  })
    .then((response) => response.json())
    .then((data) => {
      console.log(data);
      if (data.status === 422) {
        const btn = document.querySelectorAll(".ATC_btn").forEach((e) => {
          var btn_id = e.getAttribute("product-id");
          console.log(btn_id, id);
          if (btn_id.toString() === id.toString()) {
            e.innerText = "Maximum bereikt";
            e.setAttribute("disabled", true);
          }
        });
        return;
      }
      if (!cartObject) {
        return;
      }
      cartObject.classList.remove("is-empty");
      cartObject.renderContents(data);
      // product was successfully added, show success message.
      document.querySelector(".quickview_popup").classList.remove("active");
    });
}
function incrementButton_drawer() {
  const quantityInput = document.getElementById("quantity");
  quantityInput.value = parseInt(quantityInput.value) + 1;
}
function decrementButton_drawer() {
  const quantityInput = document.getElementById("quantity");

  if (quantityInput.value == 0) return;
  quantityInput.value = parseInt(quantityInput.value) - 1;
}
function Opendrawer(handle){
   let msg = "";
   console.log(handle);
     // var $gt_handle = evt.target.dataset.handle;
      var new_handle = handle;
      fetch(`/products/${new_handle}.js`)
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          var product = data;
          console.log("$product--->", product);

          // variant options js starts from here
          var variant_options = document.createElement("div");
          variant_options.setAttribute("class", `main-options`);

          // end here

          // variants loop starts from here
          var variants_main = document.createElement("div");
          variants_main.setAttribute("class", "all_variants_main");
          product.variants.forEach((e) => {
            console.log(e);
            let div = document.createElement("div");
            div.classList.add("quickadd_btn");
            let span = document.createElement("span");
            let btn = document.createElement("button");
            btn.classList.add("ATC_btn");
            btn.classList.add("button");
            btn.classList.add("button--primary");
            btn.setAttribute("product-id", e.id);
            btn.setAttribute("onclick", `AddToCart_btn(${e.id})`);
            if (e.available === false) {
              btn.setAttribute("disabled", true);
            }
            btn.innerText = "In winkelwagen";
            let icon = document.createElement("i");
            icon.classList.add("fa-solid");
            icon.classList.add("fa-cart-plus");
            icon.classList.add("ATC_icon");
            btn.appendChild(icon);
            if (e.public_title !== null) {
              span.innerText = e.public_title;
              msg = "Varianten";
            } else {
              span.innerText = "";
            }

            div.appendChild(span);
            div.appendChild(btn);
            variants_main.appendChild(div);
          });
          let variant_wrapper = document.createElement("div");
          variant_wrapper.appendChild(variants_main);
          let final_Variants = variant_wrapper.innerHTML;
          // end

          // append all html
          var options_wrapper = document.createElement("div");
          options_wrapper.appendChild(variant_options);
          var string_options_main = options_wrapper.innerHTML;
          var $html = `
                
                <div class="product-main">
                  <a class="product-media" href="${product.url}">
                    <object data="${
                      product.images[0]
                    }" type="image/webp"></object>
                  </a>
                  <div class="pro-information">

                    <span class='info_title'>${product.title}</span>
                    <span class="info_price">€ ${(product.price / 100)
                      .toFixed(2)
                      .replaceAll(".", ",")}</span>
                     <span class="input-wrapper">
                          <button id="decrement" onclick="decrementButton_drawer()">-</button>
                          <input type="number" value="1" id="quantity">
                          <button id="increment" onclick="incrementButton_drawer()">+</button>
                        </span>
                  </div>
                </div>
               <div class="Popup_ATC">
               <span class="ATC_title" >${msg}</span>
                 <ul style="all:unset;  list-style-type: none;">
                    ${final_Variants}
                 </ul>
               </div>
                  `;
          document.querySelector(
            ".quickview_popup .quickview_pro_inner"
          ).innerHTML = $html;
          document.querySelector(".quickview_popup").classList.add("active");
        });
}
 

  document
    .getElementById("close_quickview")
    .addEventListener("click", function () {
      document.querySelector(".quickview_popup").classList.remove("active");
    });
